"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAGIC_STRING_REGEX = void 0;
const widget_1 = require("./enum/widget");
exports.MAGIC_STRING_REGEX = new RegExp(`(${widget_1.MAGIC_STRINGS.join('|').replace(/\[/g, '\\[').replace(/\]/g, '\\]')})`);
